import { render, staticRenderFns } from "./AdminSpecialistBookings.vue?vue&type=template&id=d8b2d98a"
import script from "./AdminSpecialistBookings.vue?vue&type=script&lang=js"
export * from "./AdminSpecialistBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports